var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIcon = function SvgZoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 32 32",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-200-175H800v562H-200z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-icon_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 106,
    r: 102
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-icon_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 106,
    r: 100
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-icon_svg__d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107,
    cy: 106,
    r: 92
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-icon_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m135 94.06 26-19c2.27-1.85 4-1.42 4 2V135c0 3.84-2.16 3.4-4 2l-26-19zM47 77.2v43.2A17.69 17.69 0 0 0 64.77 138h63a3.22 3.22 0 0 0 3.23-3.2V91.6A17.69 17.69 0 0 0 113.23 74h-63A3.22 3.22 0 0 0 47 77.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__a)",
    transform: "translate(0 -178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 61h366v90H232z",
    fill: "#4a8cff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__a)",
    transform: "matrix(.15686 0 0 .15686 -.784 -.627)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1h214v214H0z",
    fill: "#e5e5e4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1h210v210H2z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9h194v194H10z",
    fill: "#4a8cff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 69h128v74H42z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-icon_svg__a)",
    transform: "translate(0 -178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232 19.25h180v38.17H232z",
    fill: "#90908f"
  }))));
};
export default SvgZoomIcon;